// extracted by mini-css-extract-plugin
export var container = "connect-module--container--Ktek3";
export var flex_container = "connect-module--flex_container--i-mTF";
export var img = "connect-module--img--semLj";